const CLIENT_ID = '5b578c8c0d177a310fe7';
const CLIENT_SECRET = 'e25835cb31ca4f523f3ede15004a2494ae40c6d7';
const TOKEN =
  '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';

module.exports = {
  CLIENT_ID,
  CLIENT_SECRET,
  TOKEN,
};
